
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d87d8ad2!less-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./fixedTable.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./fixedTable.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-d87d8ad2!../../node_modules/vue-loader/lib/selector?type=template&index=0!./fixedTable.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/fixedTable.vue
// module id = 211
// module chunks = 2